import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState, SpreadGroundImage } from 'editor/src/store/design/types';

const setSpreadForegroundsReducer = (state: DesignState, action: PayloadAction<SpreadGroundImage[]>) => {
  state.spreadForegrounds = action.payload;
};

export default setSpreadForegroundsReducer;
